module.exports = __webpack_public_path__ + "img/fees.monthly.8737ccfa.png";